import { Route, Switch } from "react-router-dom";

import ProductPollsPage from "@faire/prototype-playground/workspace/im/product-polls";
import ProductRequestPage from "@faire/prototype-playground/workspace/im/product-request";
import ProductRequestRetailerPage from "@faire/prototype-playground/workspace/im/product-request-retailer";
import WaitlistPage from "@faire/prototype-playground/workspace/im/waitlist";
import WaitlistRetailerPage from "@faire/prototype-playground/workspace/im/waitlist-retailer";

export function IreneMaRoutes() {
  return (
    <Switch>
      <Route path="/im/product-polls" component={ProductPollsPage} />
      <Route path="/im/product-request-retailer" component={ProductRequestRetailerPage} />
      <Route path="/im/product-request" component={ProductRequestPage} />
      <Route path="/im/waitlist-retailer" component={WaitlistRetailerPage} />
      <Route path="/im/waitlist" component={WaitlistPage} />
    </Switch>
  );
}

export const slug = "im";
